const Progress = ({ progress, bg = 'bg-zinc-900' }: { progress: number; bg?: string }) => {
  const clampedProgress = Math.min(100, Math.max(0, progress));
  return (
    <div className={`relative ${bg} w-full h-1 rounded-lg`}>
      <div
        className="h-1 w-full absolute bottom-0 rounded-lg"
        style={{
          background: 'linear-gradient(to right, #FF0000, #FFFF00, #0000FF)',
          clipPath: `inset(0 ${100 - clampedProgress}% 0 0)`,
          transition: 'clipPath 0.3s ease-in-out',
        }}
      />
    </div>
  );
};

export default Progress;
